import React from 'react'
import Page from 'src/components/Page'
import {
  makeStyles, Grid, Typography, Button,
} from '@material-ui/core'
import { ArrowLeft } from 'react-feather'
import {
  Route, Routes, useLocation, Link,
} from 'react-router-dom'
import CustomersList from './CustomersList'
import UserForm from '../account/ProfileView'

const useStyle = makeStyles(() => ({
  root: {
    padding: 10,
  },
  title: {
    marginBottom: 15,
  },
}))

export const Admin = () => {
  const classes = useStyle()
  const { pathname } = useLocation()

  return (
    <Page
      className={classes.root}
      title="مدیریت آزمون دهنده ها"
    >
      <Grid className={classes.root}>
        <Grid container justify="space-between" className={classes.title}>
          <Typography className={classes.title} variant="h3" component="h3">مدیریت آزمون دهنده ها</Typography>
          {
            pathname === '/app/customers'
              ? null
              : (
                <Link to="../customers">
                  <Button>
                    بازگشت
                    <ArrowLeft />
                  </Button>
                </Link>
              )
          }

        </Grid>
        <Routes>
          <Route path="/" element={<CustomersList />} />
          <Route path="/view/:userId" element={<UserForm />} />
        </Routes>
      </Grid>
    </Page>
  )
}

export default Admin
